export const GET_ONBOARDING_REPORT = 'GET_ONBOARDING_REPORT';
export const GET_ONBOARDING_REPORT_SUCCESS = 'GET_ONBOARDING_REPORT_SUCCESS';

export const CLIENTL3L4_CONFIG_SUCCESS = 'CLIENTL3L4_CONFIG_SUCCESS';
export const CLIENTL3L4_CONFIG_DATA = 'CLIENTL3L4_CONFIG_DATA';

export const GET_DASHBOARD_REPORT = 'GET_DASHBOARD_REPORT';
export const GET_DASHBOARD_REPORT_SUCCESS = 'GET_DASHBOARD_REPORT_SUCCESS';

export const GET_REPORT_SELECTION_SUCCESS = 'GET_REPORT_SELECTION_SUCCESS';
export const GET_REPORT_SELECTION_SUCCESS_SUCCESS = 'GET_REPORT_SELECTION_SUCCESS_SUCCESS';
